import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { calendarClassificationConsultationList } from "../../../../../../../services/calendarClassificationConsultation.service";
import { IReceivedMessageCaleClassificationsProps } from "../models";
import { calendarClassificationExamList } from "../../../../../../../services/calendarClassificationExam.service";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const ReceivedMessageCaleClassifications = memo(
  ({ automationCode }: IReceivedMessageCaleClassificationsProps) => {
    const { t } = useTranslation();

    const { sendRequest: classificationExamRequest } = useFetch(
      calendarClassificationExamList,
    );

    const { sendRequest: classificationConsultationRequest } = useFetch(
      calendarClassificationConsultationList,
    );

    const [
      optionsTicketAutomationReceivedMessageCaleClassifications,
      setOptionsTicketAutomationReceivedMessageCaleClassifications,
    ] = useState<ISelectType[]>([]);

    const params = useMemo(() => {
      if (automationCode === "21") {
        return { TypeCodeNList: ["R", "C", "X"] };
      } else if (automationCode === "25") {
        return { CalendarClassificationType: "R" };
      } else if (automationCode === "26" || automationCode === "20") {
        return { CalendarClassificationTypeNList: ["R"] };
      }
    }, [automationCode]);

    const fetchTicketAutomationReceivedMessageCaleClassifications =
      useCallback(async () => {
        let data;
        let success;
        if (automationCode === "21") {
          ({ data, success } = await classificationExamRequest(params));
        } else {
          ({ data, success } = await classificationConsultationRequest(params));
        }
        if (data && success) {
          setOptionsTicketAutomationReceivedMessageCaleClassifications(
            data.map((d) => ({
              id: d.identifier.toString(),
              name: d.name,
            })),
          );
        }
      }, [classificationConsultationRequest]);

    useEffect(() => {
      fetchTicketAutomationReceivedMessageCaleClassifications();
    }, [fetchTicketAutomationReceivedMessageCaleClassifications]);

    return (
      <Grid item xs={12} sm={12}>
        <AutoCompleteMulti
          params={params}
          fullWidth
          options={optionsTicketAutomationReceivedMessageCaleClassifications}
          name="calendarClassification"
          label={t(translationPath + "calendar_classification")}
          getOptionLabel={(option) => option.name}
          size="small"
          keepOpenOnSelect
        />
      </Grid>
    );
  },
);
